<template>
	<TimelineEvent
		:event="event"
		:class="['storeOpportunityEvent', { 'cursor-pointer': !readonly, 'is-selected': isSelected }]"
		:style="portalColorVar"
		:simplified="simplified"
		:tooltip-max-width="650"
	>
		<template #body>
			<div :class="['flex items-center overflow-hidden']">
				<PortalIcon
					v-if="portal && !simplified"
					:animation="event.is_curated_discount ? 'glow' : undefined"
					:portal="portal"
					class="icon--size-1 portalIcon mr-1"
				/>

				<span :class="['overflow-hidden text-ellipsis whitespace-nowrap', { 'is-curated': event.is_curated_discount }]">{{ event.name }}</span>
			</div>
		</template>

		<template #tooltipTitleContent
			><span class="tooltipTitle" :style="portalColorVar">{{ event.name }}</span></template
		>
	</TimelineEvent>
</template>

<script setup lang="ts">
import { PortalIcon } from '@bluebrick/saas-ui'
import { computed } from 'vue'
import { StoreToPortalMap } from '@/common/utils'
import TimelineEvent from '@/features/events/components/timeline/events/TimelineEvent.vue'
import type { EventDataWithStore } from '@/types'

const props = defineProps<{
	event: EventDataWithStore
	simplified?: boolean
	readonly?: boolean
	isSelected: boolean
}>()

const portal = computed(() => (props.event.storeName ? StoreToPortalMap.get(props.event.storeName) : undefined))
const portalColorVar = computed(() => ({
	'--event-portal-color': `var(--color-portal-${portal.value}-primary)`
}))
</script>

<style lang="scss" scoped>
.storeOpportunityEvent {
	background-color: theme('colors.level.02');
	color: theme('colors.ink.87');
	border-color: var(--event-portal-color);
	border-style: dashed;

	&:hover,
	&.is-selected {
		background-color: theme('colors.level.04');
	}

	.is-curated {
		background: var(--linear-gradient-glow);
		animation: var(--linear-gradient-glow-animation);
		background-size: 500% 100%;
		-webkit-background-clip: text;
		background-clip: text;
		color: transparent;
	}
}

.tooltipTitle {
	color: var(--event-portal-color);
}
</style>
